

import Vue from "vue";
import navbar from "@/components/Nav.vue";
import footerr from "@/components/Footerr.vue";

export default Vue.extend({
  name: "App",
  components: {
    navbar,
    footerr
  },
  data: () => ({
    // items: ['Foo', 'Bar', 'Fizz', 'Buzz'],
  }),
});

